<template>
    <div class="analytics">
        <Header :app="app" :left="true" title="Analytics">
            <template v-slot:left>
                <router-link to="/">
                    &laquo;
                </router-link>
            </template>
        </Header>

        <div class="content">
            <div class="header">
                <div class="columns">
                    <div class="column third-column">
                        <input type="date" v-model="startAt">
                    </div>
                    <div class="column third-column desktop-only">
                        <p>to</p>
                    </div>
                    <div class="column third-column">
                        <input type="date" v-model="endAt">
                    </div>
                </div>
                <select v-model="selectedLocation">
                    <option value="">All Locations</option>
                    <option v-for="location in app.sortedLocations" :key="location.id" :value="location">
                        {{location.name}}
                    </option>
                </select>
            </div>

            <!-- <div v-if="dates.length > 1">
                <div class="graph">
                    <TrendChart
                      :datasets="[
                        {
                          data: [10, 50, 20, 100, 40, 60, 80],
                          smooth: true
                        }
                      ]"
                      :labels="{
                         xLabels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                         yLabels: 5
                      }"
                      :min="0">
                    </TrendChart>
                </div>
            </div> -->

            <div class="columns">
                <div :class="'column ' + (dates.length === 1 ? 'half' : 'third') + '-column'">
                    <div class="graph number-graph">
                        <h1>{{allData.peopleIds.length}}</h1>
                        <p>How many people were present in total?</p>
                    </div>
                </div>
                <div class="column third-column" v-if="dates.length !== 1">
                    <div class="graph number-graph">
                        <h1>{{Math.floor(allData.peopleIds.length / dates.length)}}</h1>
                        <p>How many were present on average?</p>
                    </div>
                </div>
                <div :class="'column ' + (dates.length === 1 ? 'half' : 'third') + '-column'">
                    <div class="graph number-graph">
                        <h1>{{allData.presents}}</h1>
                        <p>How many times were people present?</p>
                    </div>
                </div>
            </div>

            <div v-if="!selectedLocation">
                <table class="table">
                    <thead>
                        <tr>
                            <th class="with-padding"></th>
                            <th v-for="date in dates" :key="'heading-' + date" class="with-padding">
                                {{app.formatDate(date)}}
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="g in allData.locations" :key="'data-location-' + g.location.id">
                            <td class="with-padding align-left">
                                {{g.location.name}}
                            </td>
                            <td v-for="date in g.dates" :key="'location-heading-' + g.location.id + '-' + date" class="with-padding">
                                {{date}}
                            </td>
                        </tr>
                    </tbody>

                    <tfoot>
                        <tr>
                            <td class="with-padding align-left">
                                Total Present
                            </td>
                            <td v-for="(total, date) in allData.dates" :key="'total-' + date" class="with-padding">
                                {{total}}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <div v-else>
                <table class="table">
                    <thead>
                        <tr>
                            <th class="with-padding align-left">
                                Name
                            </th>
                            <th v-for="date in dates" :key="'date-heading2-' + date" class="with-padding">
                                {{app.formatDate(date)}}
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-if="!people.length">
                            <td :colspan="dates.length + 1" class="with-padding">
                                No information to display.
                            </td>
                            <td class="with-padding"></td>
                        </tr>
                        <tr v-for="person in sortedPeople" :key="person.id">
                            <td class="with-padding align-left">
                                {{person.name}}
                            </td>
                            <td v-for="date in dates" :key="'people-date-' + date" class="icons with-padding">
                                <span v-if="app.isPresent(selectedLocation, person, date)" class="check">&check;</span>
                                <span v-else>&times;</span>
                            </td>
                        </tr>
                    </tbody>

                    <tfoot>
                        <tr>
                            <td class="with-padding">
                                Total Present
                            </td>
                            <td v-for="(date, d) in allData.dates" :key="'total-present-' + d" class="with-padding">
                                {{date}}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>

        </div>
    </div>
</template>

<script>
import Vue        from 'vue';
import Header     from '@/components/header/component.vue';
import TrendChart from 'vue-trend-chart';

Vue.use(TrendChart);

function parseDate(date) {
    var y = date.substr(0, 4),
        m = date.substr(5, 2) - 1,
        d = date.substr(8, 2),
        newDate = new Date(y, m, d);

    return (newDate.getFullYear() == y && newDate.getMonth() == m && newDate.getDate() == d) ? newDate : 'invalid date';
}

export default {
    name: 'analytics',
    components: {
        Header
    },
    props: ['app'],
    data() {
        var _ = this,
            startAt = new Date(),
            endAt = new Date();

        startAt.setDate(startAt.getDate() - 31);

        return {
            selectedLocation: '',
            startAt: startAt.getFullYear() + '-' + _.app.zeroPad(startAt.getMonth() + 1) + '-' + _.app.zeroPad(startAt.getDate()),
            endAt: endAt.getFullYear() + '-' + _.app.zeroPad(endAt.getMonth() + 1) + '-' + _.app.zeroPad(endAt.getDate()),
        };
    },
    computed: {
        allData() {
            var _ = this,
                locations = _.selectedLocation ? [_.selectedLocation] : _.app.locations,
                people = _.app.people,
                dates = _.dates,
                data = {
                    peopleIds: [],
                    presents: 0,
                    locations: [],
                    dates: {}
                },
                location, locationWrapper, dateWrapper, person, present, date, i, n, p;

            for (n = 0; n < dates.length; n++) {
                data.dates[_.app.prepDate(dates[n])] = 0;
            }

            for (i = locations.length - 1; i >= 0; i--) {
                location = locations[i];
                locationWrapper = { location: location, peopleIds: [], presents: 0, dates: {} };
                data.locations.push(locationWrapper);

                for (n = 0; n < dates.length; n++) {
                    date = _.app.prepDate(dates[n]);
                    dateWrapper = { presents: 0, peopleIds: [] };
                    locationWrapper.dates[date] = 0;

                    for (p = people.length - 1; p >= 0; p--) {
                        person = people[p];
                        present = _.app.isPresent(location, person, date);

                        if (present) {
                            data.presents += 1;
                            if (data.peopleIds.indexOf(person.id) === -1) {
                                data.peopleIds.push(person.id);
                            }

                            dateWrapper.presents += 1;
                            if (dateWrapper.peopleIds.indexOf(person.id) === -1) {
                                dateWrapper.peopleIds.push(person.id);
                            }

                            locationWrapper.presents += 1;
                            locationWrapper.dates[date] += 1;
                            if (locationWrapper.peopleIds.indexOf(person.id) === -1) {
                                locationWrapper.peopleIds.push(person.id);
                            }

                            data.dates[date] += 1;
                        }
                    }
                }
            }

            data.locations = data.locations.sort(_.app.sortByLocationName);

            return data;
        },
        dates() {
            var _ = this,
                people = _.app.people,
                location = _.selectedLocation ? _.selectedLocation : _.app.locations,
                startAt = parseDate(_.startAt),
                endAt = parseDate(_.endAt),
                dates = [startAt],
                i;

            if (!startAt) return [];

            while (startAt < endAt) {
                startAt = new Date(startAt);
                startAt.setDate( startAt.getDate() + 1 );

                for (i = people.length - 1; i >= 0; i--) {
                    if (_.app.isPresent(location, people[i], _.app.prepDate(startAt))) {
                        dates.push(startAt);
                        break;
                    }
                }
            }

            return dates;
        },
        sortedPeople() {
            var _ = this;

            return _.people.sort(_.app.sortByName);
        },
        people() {
            return this.app.people || [];
        }
    }
};
</script>
